import {
  brandGovernanceAccessGuard,
  constellationProAccessGuard,
} from '@/app/constellationPro/utils/route-guards';

const App = () => import('@/app/constellationPro/App.vue');
const BrandGuidelines = () => import('@/app/constellationPro/pages/BrandGuidelines.vue');
const Governance = () => import('@/app/constellationPro/pages/Governance.vue');
const Home = () => import('@/app/constellationPro/pages/Home.vue');
const Library = () => import('@/app/constellationPro/pages/Library.vue');
const ProjectDetail = () => import('@/app/constellationPro/pages/ProjectDetail.vue');
const ProjectsList = () => import('@/app/constellationPro/pages/ProjectsList.vue');

const PAGE_LEVEL_TOP = 'Constellation Pro';

export default {
  path: 'constellation-pro',
  component: App,
  beforeEnter: constellationProAccessGuard,
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      name: 'constellation-pro',
      path: '',
      redirect: { name: 'constellation-pro.overview' },
    },
    {
      name: 'constellation-pro.overview',
      path: 'overview',
      component: Home,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Overview`,
      },
    },
    {
      name: 'constellation-pro.brand-guidelines',
      path: 'brand-guidelines',
      component: BrandGuidelines,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Brand Guidelines`,
      },
    },
    {
      name: 'constellation-pro.governance',
      path: 'governance',
      component: Governance,
      beforeEnter: brandGovernanceAccessGuard,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Governance`,
      },
    },
    {
      name: 'constellation-pro.projects',
      path: 'boards',
      component: ProjectsList,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Projects`,
      },
    },
    {
      name: 'constellation-pro.projects.detail',
      path: 'projects/:projectId',
      component: ProjectDetail,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Project Detail`,
      },
    },
    {
      name: 'constellation-pro.library',
      path: 'library',
      component: Library,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Library`,
      },
    },
  ],
};
